import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';
import { BorrowerDTO } from '../../models/borrower/borrower-dto';
import { panNumberValidator, confirmPanValidation } from '../../validations/pan-number-validation.directive';
import { pincodeValidator } from 'src/app/validations/pincode-validation.directive';
import { tinNumberValidator, confirmTinValidation } from 'src/app/validations/tin-validation.directive';
import { IncomeDTO } from '../../models/borrower/income-dto';
import { netSalaryValidator, itrIncomeValidation } from '../../validations/salary-validation.directive';
import { LoanStep3 } from '../../models/borrower/loan-step3';
import { SearchQuote } from '../../models/search/search-quote';
import { Login } from '../../models/login/sendLoginDetails';
import { confirmEmailValidation } from 'src/app/validations/email-validation.directive';
import { confirmMobileValidation } from 'src/app/validations/mobile-validation.directive';
import { NewQuote } from 'src/app/models/search/new-quote';
import { LoanStep1 } from 'src/app/models/borrower/loan-step1';
import { LoanStep2 } from 'src/app/models/borrower/loan-step2';
import { nameValidation, midNameValidation } from 'src/app/validations/name-validation.directive';
import { CustomerSignupDTO } from 'src/app/models/login/customerSignup';
import { Form2Personal } from 'src/app/models/form2Personal';
import { Form2Reference } from 'src/app/models/form2Reference';
import { Form2BankDetails } from 'src/app/models/form2BankDetails';
import { approvalDate } from 'src/app/models/approvalDate';
import { dateValidator } from 'src/app/validations/date-validation.directive';
import { toDateValidator } from 'src/app/validations/to-date-validation.directive';
import { Workload } from 'src/app/models/workload';
import { downpaymentMaxValidator, downpaymentMinValidator } from 'src/app/validations/downpayment-validation.directive';

@Injectable({
  providedIn: 'root'
})
export class FormBuilderService {

  numberRegex = /\d/;
  phoneRegex = '^([6-9]{1})+([0-9])*$'
  stringRegex = '^[a-zA-Z]+( [a-zA-z]+)*$';
  nameRegex = '^[a-zA-Z]+( [a-zA-Z]*){0,2}$';
  alphaNumericRegex = '^[a-zA-Z0-9 ]*$';
  // panRegex = '^([A-Z]){3}([CPHFATBLJG]){1}([A-Z])([0-9]){4}([A-Z])?$';
  panRegex = '^([A-Z]){3}([P]){1}([A-Z])([0-9]){4}([A-Z])?$';
  twoDigitNumericRegex = '^([1-9]{1}[0-9]{0,})+([.][0-9]{0,2})?$';
  itrRegex = '^([0-9]{1,2})+((,[0-9]{2})*(,[0-9]{3}))*([.][0-9]{0,2})?$';
  emailRegex = '^[-A-Za-z0-9_.+]+@[-A-Za-z0-9_]+([.][A-Za-z]{2,3}){1,2}';
  designationRegex = '^(?![0-9])^[a-zA-Z0-9 ]*$';
  subventionRegex = '^[0-9]+([.][0-9]{0,2})?$';

  constructor() { }

  buildIndividualPersonalForm({ form, borrower, typeOfBorrower }: { form: FormGroup; borrower: BorrowerDTO; typeOfBorrower: string; }) {
    let isCoApplicant: boolean = true;
    if (typeOfBorrower == 'primary') {
      isCoApplicant = false;
    }
    let group = {
      'firstName': new FormControl(borrower.firstName,
        [
          Validators.required,
          Validators.maxLength(30),
          Validators.minLength(1),
          Validators.pattern(new RegExp(this.nameRegex))
        ]),
      'middleName': new FormControl(borrower.middleName,
        [
          // Validators.maxLength(30),
          // Validators.minLength(1),
          // Validators.pattern(new RegExp(this.stringRegex))
        ]),
      'lastName': new FormControl(borrower.lastName,
        [
          // Validators.required,
          // Validators.maxLength(20),
          // Validators.minLength(1),
          // Validators.pattern(new RegExp(this.nameRegex))
        ]),

      'gender': new FormControl(borrower.gender, Validators.required),
      'ownershipType': new FormControl(borrower.ownershipType,
        Validators.required),
      'maritalStatus': new FormControl(borrower.maritalStatus,
        Validators.required),
      'primaryMobilePhone': new FormControl(
        borrower.cstPhoneDto[0].phoneNum,
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.pattern(new RegExp(this.phoneRegex)),
          Validators.minLength(10)
        ]),
      'otherMobilePhone': new FormControl(
        borrower.cstPhoneDto[1].phoneNum),
      'primaryEmail': new FormControl(
        borrower.cstEmailDto[0].emailAddr,
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.pattern(new RegExp(this.emailRegex))
        ]),
      'secondaryEmail': new FormControl(
        borrower.cstEmailDto[1].emailAddr,
        [
          Validators.pattern(new RegExp(this.emailRegex))
        ]),
      'dateOfBirth': new FormControl(borrower.birthDate,
        Validators.required),
      'panNumber': new FormControl(borrower.cstCustPiiDto[0].docKey),
      'confirmPANNumber': new FormControl(borrower.cstCustPiiDto[0].docKey),
      'aadhar': new FormControl(borrower.cstCustPiiDto[1].docKey,
        [
          Validators.maxLength(12),
          Validators.minLength(12),
          Validators.pattern(new RegExp(this.numberRegex)),
        ]),
      'currentBuildingNo': new FormControl(borrower.cstAddrDto[0].buildingName,
        [
          Validators.required,
          Validators.maxLength(40),
          Validators.minLength(10),
          Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'currentStreetName': new FormControl(borrower.cstAddrDto[0].streetName,
        [
          Validators.required,
          Validators.maxLength(40),
          Validators.minLength(10)
          //   Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'currentCity': new FormControl(borrower.cstAddrDto[0].ndIndCity.cityDesc,
        [
          Validators.required,
          Validators.maxLength(25)
        ]),
      'currentState': new FormControl(borrower.cstAddrDto[0].ndIndState.stateDesc,
        Validators.required),
      'currentArea': new FormControl(borrower.cstAddrDto[0].ndIndLocality.localityCode,
        [
          Validators.required,
          Validators.maxLength(50),
          // Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'currentLandmark': new FormControl(borrower.cstAddrDto[0].landmark,
        [
          Validators.required,
          Validators.maxLength(40),
          Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'currentPinCode': new FormControl(borrower.cstAddrDto[0].postalCode),

      'permanentBuildingNo': new FormControl(borrower.cstAddrDto[1].buildingName,
        [
          Validators.required,
          Validators.maxLength(40),
          Validators.minLength(10),
          Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'permanentStreetName': new FormControl(borrower.cstAddrDto[1].streetName,
        [
          Validators.required,
          Validators.maxLength(40),
          Validators.minLength(10),
          //  Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'permanentCity': new FormControl(borrower.cstAddrDto[1].ndIndCity.cityDesc,
        [
          Validators.required,
          Validators.maxLength(25)
        ]),
      'permanentState': new FormControl(borrower.cstAddrDto[1].ndIndState.stateDesc,
        Validators.required),
      'permanentArea': new FormControl(borrower.cstAddrDto[1].ndIndLocality.localityCode,
        [
          Validators.required,
          Validators.maxLength(50),
          // Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'permanentLandmark': new FormControl(borrower.cstAddrDto[0].landmark,
        [
          Validators.required,
          Validators.maxLength(40),
          Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'permanentPinCode': new FormControl(borrower.cstAddrDto[1].postalCode),
    };

    if (isCoApplicant) {
      group['relationshipPrimary'] = new FormControl(borrower.relationshipPrimary, Validators.required);
      group['applicantType'] = new FormControl(borrower.applicantTypeTypcode, Validators.required);
      // group['occupationStatus'] = new FormControl(borrower.occupationStatus, Validators.required);
    }

    form = new FormGroup(group, { updateOn: 'blur' });
    if (form) {
      let validator: any = {
        required: true,
        // panNumberValidator: true,
        pattern: this.panRegex
      }
      this.addDynamicValidators(form.controls['panNumber'] as FormControl, validator, form, 0, 0);

      validator = {
        required: true,
        nameValidation: true,
        maxLength: 20,
        minLength: 1,
        pattern: this.nameRegex
      }
      this.addDynamicValidators(form.controls['lastName'] as FormControl, validator, form, 0, 0);

      validator = {
        midNameValidation: true,
        maxLength: 30,
        minLength: 1,
        pattern: this.nameRegex
      }
      this.addDynamicValidators(form.controls['middleName'] as FormControl, validator, form, 0, 0);

      validator = {
        required: true,
        confirmPanValidation: true,
        pattern: this.panRegex,
        // panNumberValidator: true,
      }
      this.addDynamicValidators(form.controls['confirmPANNumber'] as FormControl, validator, form, 0, 0);

      validator = {
        confirmMobileValidation: true,
        maxLength: 10,
        minLength: 10,
        pattern: this.phoneRegex
      }
      this.addDynamicValidators(form.controls['otherMobilePhone'] as FormControl, validator, form, 0, 0);

      validator = {
        pattern: this.emailRegex,
        confirmEmailValidation: true,
        maxLength: 60
      }
      this.addDynamicValidators(form.controls['secondaryEmail'] as FormControl, validator, form, 0, 0);

      validator = {
        required: true,
        pincodeValidator: true,
        maxLength: 6
      }
      this.addDynamicValidators(form.controls['currentPinCode'] as FormControl, validator, form, 0, 0);

      this.addDynamicValidators(form.controls['permanentPinCode'] as FormControl, validator, form, 0, 0);
    }
    return form;
  }

  // buildOrganisationPersonalForm(form: FormGroup, borrower: BorrowerDTO, typeOfBorrower: string) {
  //   let isCoApplicant: boolean = true;
  //   if (typeOfBorrower == 'primary') {
  //     isCoApplicant = false;
  //   }
  //   let group = {
  //     'organisationName': new FormControl(borrower.organizationName,
  //       [
  //         Validators.required,
  //         Validators.maxLength(60),
  //         Validators.pattern(new RegExp(this.alphaNumericRegex))
  //       ]),
  //     'businessType': new FormControl(borrower.businessType,
  //       [
  //         Validators.maxLength(60),
  //         Validators.required
  //       ]),
  //     'contactPerson': new FormControl(borrower.contactPerson,
  //       [
  //         Validators.required,
  //         Validators.maxLength(60),
  //         Validators.pattern(new RegExp(this.stringRegex))
  //       ]),
  //     'primaryMobilePhone': new FormControl(
  //       borrower.cstPhoneDto[0].phoneNum,
  //       [
  //         Validators.required,
  //         Validators.maxLength(10),
  //         Validators.minLength(10),
  //         Validators.pattern(new RegExp(this.phoneRegex))
  //       ]),
  //     'otherMobilePhone': new FormControl(
  //       borrower.cstPhoneDto[1].phoneNum, [
  //         Validators.maxLength(10),
  //         Validators.minLength(10),
  //         Validators.pattern(new RegExp(this.phoneRegex))
  //       ]),
  //     'gstin': new FormControl(borrower.gstin),
  //     'confirmGstin': new FormControl(borrower.gstin),
  //     'currentBuildingNo': new FormControl(
  //       borrower.cstAddrDto[0].buildingName,
  //       [
  //         Validators.required,
  //         Validators.maxLength(50),
  //         Validators.pattern(new RegExp(this.alphaNumericRegex))
  //       ]),
  //     'currentStreetName': new FormControl(
  //       borrower.cstAddrDto[0].streetName,
  //       [
  //         Validators.required,
  //         Validators.maxLength(50),
  //         Validators.pattern(new RegExp(this.alphaNumericRegex))
  //       ]),
  //     'currentCity': new FormControl(borrower.cstAddrDto[0].ndIndCity.cityDesc,
  //       [
  //         Validators.required,
  //         Validators.maxLength(25),
  //         Validators.pattern(new RegExp(this.alphaNumericRegex))
  //       ]),
  //     'currentState': new FormControl(borrower.cstAddrDto[0].ndIndState.stateDesc,
  //       Validators.required),
  //     'currentArea': new FormControl(borrower.cstAddrDto[0].ndIndLocality,
  //       [
  //         Validators.required,
  //         Validators.maxLength(50),
  //         // Validators.pattern(new RegExp(this.alphaNumericRegex))
  //       ]),
  //     'currentLandmark': new FormControl(borrower.cstAddrDto[0].landmark),
  //     'currentPinCode': new FormControl(borrower.cstAddrDto[0].postalCode),
  //   };

  //   form = new FormGroup(group, { updateOn: 'blur' });
  //   if (form) {
  //     let validator: any = {
  //       required: true,
  //       pincodeValidator: true,
  //       maxLength: 6
  //     }
  //     this.addDynamicValidators(form.controls['currentPinCode'] as FormControl, validator, form);

  //     validator = {
  //       required: true,
  //       tinNumberValidator: true,
  //       maxLength: 15
  //     }
  //     this.addDynamicValidators(form.controls['gstin'] as FormControl, validator, form);

  //     validator = {
  //       required: true,
  //       confirmTinValidation: true
  //     }
  //     this.addDynamicValidators(form.controls['confirmGstin'] as FormControl, validator, form);
  //   }
  //   return form;
  // }

  buildIndividualSalariedIncomeForm(form: FormGroup, incomeBorrower: IncomeDTO) {

    let group = {
      'occupationStatus': new FormControl(incomeBorrower.occupationTypcode, Validators.required),
      'designation': new FormControl(incomeBorrower.designation, [
        Validators.required,
        Validators.maxLength(60),
        Validators.minLength(2),
        Validators.maxLength(30),
        Validators.pattern(new RegExp(this.designationRegex))
      ]),
      'grossSalary': new FormControl("", [
        Validators.required,
        Validators.maxLength(15),
        Validators.pattern(new RegExp(this.itrRegex))
      ]
      ),
      'netSalary': new FormControl("",
        [
          // Validators.required,
          // Validators.maxLength(15),
          // Validators.pattern(new RegExp(this.twoDigitNumericRegex))
        ]),
      // 'abbToEmi': new FormControl(
      //   (incomeBorrower.abbToEmi),
      //   [
      //     Validators.required
      //   ]),
      'organisationName': new FormControl(
        incomeBorrower.organisationName,
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.pattern(new RegExp(this.designationRegex))
        ]),

      'longevity': new FormControl((incomeBorrower.longevityId),
        [
          Validators.required,
        ]),
      'salaryCredit': new FormControl(incomeBorrower.salCredBankFlag),
      'officeBuildingNo': new FormControl(incomeBorrower.cstAddrDto.buildingName,
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.minLength(10),
          Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'officeStreetName': new FormControl(incomeBorrower.cstAddrDto.streetName,
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.minLength(10)
          //   Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'officeCity': new FormControl(incomeBorrower.cstAddrDto.ndIndCity.cityDesc,
        [
          Validators.required,
          Validators.maxLength(25)
        ]),
      'officeState': new FormControl(incomeBorrower.cstAddrDto.ndIndState.stateDesc,
        Validators.required),
      'officeArea': new FormControl(incomeBorrower.cstAddrDto.ndIndLocality.localityCode,
        [
          Validators.required,
          Validators.maxLength(50),
          // Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'officeLandmark': new FormControl(incomeBorrower.cstAddrDto.landmark,
        [
          Validators.required,
          Validators.maxLength(80),
          Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'officePinCode': new FormControl(incomeBorrower.cstAddrDto.postalCode, Validators.required),
    };

    form = new FormGroup(group, { updateOn: 'blur' });
    if (form) {
      let validator: any = {
        required: true,
        netSalaryValidator: true,
        pattern: this.itrRegex,
        maxLength: 15
      }
      this.addDynamicValidators(form.controls['netSalary'] as FormControl, validator, form, 0, 0);
    }
    return form;
  }

  buildIndividualSelfEmployedIncomeForm(form: FormGroup, incomeBorrower: IncomeDTO) {

    let group = {
      'occupationStatus': new FormControl(incomeBorrower.occupationTypcode, Validators.required),
      'annualIncome': new FormControl("", [
        Validators.required,
        Validators.maxLength(15),
        Validators.pattern(this.itrRegex)
      ]
      ),
      'itrIncome': new FormControl("",
        //  [
        //   Validators.required,
        //   Validators.maxLength(15),
        //   Validators.pattern(new RegExp(this.twoDigitNumericRegex))
        // ]
      ),
      'aproxAvgBankBal': new FormControl(
        "",
        [
          Validators.required,
          Validators.pattern(new RegExp(this.itrRegex))
          // Validators.maxLength(8),
          // Validators.pattern(new RegExp(this.numberRegex))
        ]),
      'organisationName': new FormControl(
        incomeBorrower.organisationName,
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.pattern(new RegExp(this.designationRegex))
        ]),
      'officeBuildingNo': new FormControl(incomeBorrower.cstAddrDto.buildingName,
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.minLength(10),
          Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'officeStreetName': new FormControl(incomeBorrower.cstAddrDto.streetName,
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.minLength(10)
          //   Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'officeCity': new FormControl(incomeBorrower.cstAddrDto.ndIndCity.cityDesc,
        [
          Validators.required,
          Validators.maxLength(25)
        ]),
      'officeState': new FormControl(incomeBorrower.cstAddrDto.ndIndState.stateDesc,
        Validators.required),
      'officeArea': new FormControl(incomeBorrower.cstAddrDto.ndIndLocality.localityCode,
        [
          Validators.required,
          Validators.maxLength(50),
          // Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'officeLandmark': new FormControl(incomeBorrower.cstAddrDto.landmark,
        [
          Validators.required,
          Validators.maxLength(80),
          Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'officePinCode': new FormControl(incomeBorrower.cstAddrDto.postalCode, Validators.required),
    };

    form = new FormGroup(group, { updateOn: 'blur' });
    if (form) {
      let validator: any = {
        required: true,
        itrIncomeValidation: true,
        pattern: this.itrRegex,
        maxLength: 15
      }
      this.addDynamicValidators(form.controls['itrIncome'] as FormControl, validator, form, 0, 0);
    }
    return form;
  }

  // buildOrganisationIncomeForm(form: FormGroup, incomeBorrower: IncomeDTO) {

  //   let group = {
  //     'organisationName': new FormControl(
  //       incomeBorrower.organisationName,
  //       [
  //         Validators.required,
  //         Validators.maxLength(25),
  //         Validators.pattern(new RegExp(this.alphaNumericRegex))
  //       ]),
  //     'itrIncome': new FormControl(+(incomeBorrower.itrIncome), [
  //       Validators.required,
  //       Validators.maxLength(16),
  //       Validators.pattern(new RegExp(this.twoDigitNumericRegex))
  //     ]
  //     ),
  //     'officeBuildingNo': new FormControl(incomeBorrower.cstAddrDto.buildingName,
  //       [
  //         Validators.required,
  //         Validators.maxLength(60),
  //         Validators.pattern(new RegExp(this.alphaNumericRegex))
  //       ]),
  //     'officeStreetName': new FormControl(incomeBorrower.cstAddrDto.streetName,
  //       [
  //         Validators.required,
  //         Validators.maxLength(60),
  //         //   Validators.pattern(new RegExp(this.alphaNumericRegex))
  //       ]),
  //     'officeCity': new FormControl(incomeBorrower.cstAddrDto.ndIndCity.cityDesc,
  //       [
  //         Validators.required,
  //         Validators.maxLength(25)
  //       ]),
  //     'officeState': new FormControl(incomeBorrower.cstAddrDto.ndIndState.stateDesc,
  //       Validators.required),
  //     'officeArea': new FormControl(incomeBorrower.cstAddrDto.ndIndLocality.localityCode,
  //       [
  //         Validators.required,
  //         Validators.maxLength(50),
  //         // Validators.pattern(new RegExp(this.alphaNumericRegex))
  //       ]),
  //     'officeLandmark': new FormControl(incomeBorrower.cstAddrDto.landmark,
  //       [
  //         Validators.required,
  //         Validators.maxLength(80),
  //         Validators.pattern(new RegExp(this.alphaNumericRegex))
  //       ]),
  //     'officePinCode': new FormControl(incomeBorrower.cstAddrDto.postalCode),
  //   }

  //   form = new FormGroup(group/*, { updateOn: 'blur' }*/);
  //   return form;
  // }

  buildDealerSubventionForm(form: FormGroup, dealersubvention: LoanStep3, maxPayout) {
    let group = {
      'maxPayout': new FormControl(dealersubvention.maxPayout),
      'subvention': new FormControl(dealersubvention.subvention, [
        Validators.max(maxPayout),
        Validators.pattern(this.subventionRegex)
      ]),
      'balancePayout': new FormControl(dealersubvention.balancePayout),
      'additionalSubvention': new FormControl(dealersubvention.additionalSubvention, [
        Validators.maxLength(50),
        Validators.pattern(this.itrRegex)
      ]
      ),
      'dealerSubvention': new FormControl(dealersubvention.dealerSubvention)
    }
    form = new FormGroup(group, { updateOn: 'blur' });
    return form;
  }

  // buildLoanForm(form: FormGroup, loanBorrower: LoanBorrowerDTO) {
  //   let group = {
  //     'financialProduct': new FormControl(loanBorrower.indFinanceProductEntityIdDto, Validators.required),
  //     // 'financialScheme': new FormControl(loanBorrower.indFinanceSchemeEntityIdDto),
  //     'specialProgram': new FormControl(loanBorrower.indFinanceSplpgmEntityIdDto),
  //     'additionalFees': new FormControl(loanBorrower.additionalFees, [
  //       Validators.maxLength(8),
  //     ]),
  //     'discount': new FormControl(loanBorrower.discount, [
  //       Validators.maxLength(8),
  //     ]),
  //     'interestRate': new FormControl(
  //       loanBorrower.interestRate,
  //       [
  //         Validators.required,
  //         Validators.pattern(new RegExp(this.twoDigitNumericRegex))
  //       ]
  //     ),
  //     'tenor': new FormControl(
  //       loanBorrower.tenureMonths),
  //     'downPaymentAmount': new FormControl(
  //       loanBorrower.downpaymentAmount,
  //       [
  //         Validators.required,
  //         Validators.maxLength(8)
  //       ]),
  //     'downpaymentValue': new FormControl(
  //       loanBorrower.downpaymentValue, Validators.required),
  //     'repaymentVariation': new FormControl(loanBorrower.repaymentVariationEntityIdDto, Validators.required),
  //   };
  //   form = new FormGroup(group, { updateOn: 'blur' });
  //   return form;
  // }

  buildFinancialProductForm(form: FormGroup, loanBorrowerStep1: LoanStep1) {
    let group = {
      'financialProduct': new FormControl(loanBorrowerStep1.productId, Validators.required),
      'specialProgram': new FormControl(loanBorrowerStep1.splpgmId),
    }
    form = new FormGroup(group, { updateOn: 'blur' });
    return form;
  }

  buildLoanTermsForm(form: FormGroup, loanBorrowerStep2: LoanStep2) {
    let group = {
      'discount': new FormControl(loanBorrowerStep2.discount, [
        // Validators.maxLength(8),
        Validators.pattern(new RegExp(this.itrRegex))
      ]),
      'tenor': new FormControl(loanBorrowerStep2.tenureMonths, [
        Validators.required,
      ]),
      'downPaymentAmount': new FormControl(
        loanBorrowerStep2.downpaymentAmount,
        [
          Validators.required,
          Validators.pattern(new RegExp(this.itrRegex))
          // Validators.pattern(new RegExp(this.twoDigitNumericRegex))
        ]),
      'downpaymentValue': new FormControl(
        loanBorrowerStep2.downpaymentRate,
        [
          Validators.required,
          // Validators.pattern(new RegExp(this.itrRegex))
        ]),
      'repaymentVariation': new FormControl(loanBorrowerStep2.quotRepayMapDto.repayTypcode),
    }
    form = new FormGroup(group, { updateOn: 'blur' });
    return form;
  }

  // buildSubProductMap(form: FormGroup, loanBorrowerStep4: LoanStep2) {
  //   'discount': new FormControl(loanBorrowerStep2.discount, [
  //     Validators.maxLength(8)
  //   ]),
  //     'tenor': new FormControl(loanBorrowerStep2.tenureMonths, [
  //       Validators.required,
  //     ]),
  //       'downPaymentAmount': new FormControl(
  //         loanBorrowerStep2.downpaymentAmount,
  //         [
  //           Validators.required,
  //           Validators.maxLength(8)
  //         ]),
  // }

  buildNewQuoteForm(form: FormGroup, quote: NewQuote) {
    let group = {
      'brand': new FormControl(quote.newVehBrandId, Validators.required),
      'model': new FormControl(quote.newVehModelId, Validators.required),
      'variant': new FormControl(quote.newVehVariantId, Validators.required),
      'exShowRoomPrice': new FormControl(quote.exShowroomPrice, Validators.required)
    }
    form = new FormGroup(group, { updateOn: 'blur' });
    return form;
  }

  buildUsedQuoteForm(form: FormGroup, quote: NewQuote) {
    let group = {
      'bank': new FormControl(quote.newVehBrandId, Validators.required),
      'brand': new FormControl(quote.usedVehBrandId, Validators.required),
      'model': new FormControl(quote.newVehModelId, Validators.required),
      'variant': new FormControl(quote.newVehVariantId, [
        Validators.required,
        Validators.maxLength(25),
        Validators.pattern(new RegExp(this.alphaNumericRegex))
      ]),
     'exShowRoomPrice': new FormControl(quote.exShowroomPrice, [
      Validators.required,
      Validators.min(1) // Ensures the price is greater than zero
    ])    }
    form = new FormGroup(group, { updateOn: 'change' });
    return form;
  }

  buildSearchQuoteForm(form: FormGroup, quote: SearchQuote) {
    let group = {
      'quotationStatus': new FormControl(quote.quotationStatus),
      'applicantName': new FormControl(quote.applicantName,
        [
          Validators.maxLength(75),
          Validators.pattern(new RegExp(this.stringRegex))
        ]),
      'panNumber': new FormControl(quote.panNumber,
        [
          Validators.pattern(new RegExp(this.panRegex))
        ]),
      'phoneNum': new FormControl(quote.phoneNo,
        [
          Validators.maxLength(10),
          Validators.pattern(new RegExp(this.numberRegex)),
          Validators.minLength(10)
        ]
      ),
      'dateOfBirth': new FormControl(quote.dob),
    };
    form = new FormGroup(group, { updateOn: 'change' });
    if (form) {
      let validator: any = {
        // panNumberValidator: true,
        pattern: this.panRegex,
        maxLength: 10
      }
      this.addDynamicValidators(form.controls['panNumber'] as FormControl, validator, form, 0, 0);
    }
    return form;
  }

  buildLoginForm(form: FormGroup, login: Login) {
    let group = {
      'userName': new FormControl(login.userId,
        [
          Validators.required
        ]
      ),
      'password': new FormControl(login.password,
        [
          Validators.required
        ]
      )
    };
    form = new FormGroup(group, { updateOn: 'change' });
    return form;
  }

  buildCustomerSignupForm(form: FormGroup, signup: CustomerSignupDTO) {
    let group = {
      'userName': new FormControl(signup.userName,
        [
          Validators.required
        ]
      ),
      'mobilePhone': new FormControl(
        signup.phoneNo,
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.pattern(new RegExp(this.phoneRegex)),
          Validators.minLength(10)
        ]),
      'firstName': new FormControl(signup.firstName,
        [
          Validators.required,
          Validators.maxLength(32),
          Validators.minLength(1),
          Validators.pattern(new RegExp(this.nameRegex))
        ]),
      'password': new FormControl(signup.password,
        [
          Validators.required
        ]
      ),
      'confirmPassword': new FormControl(signup.confirmPassword,
        [
          Validators.required
        ]
      )
    };
    form = new FormGroup(group, { updateOn: 'change' });
    return form;
  }

  buildForm2PersonalForm(form: FormGroup, personal: Form2Personal) {

    let group = {
      'maidenName': new FormControl(personal.maidenName,
        [
          Validators.required,
          Validators.maxLength(30),
          Validators.minLength(1),
          Validators.pattern(new RegExp(this.stringRegex))
        ]),
      'occupationType': new FormControl(personal.occupationType,
        Validators.required),
      'industry': new FormControl(personal.industry,
        Validators.required),
      'educationalQualification': new FormControl(personal.educationalQualification,
        Validators.required),
      'residenceType': new FormControl(personal.residenceType,
        Validators.required),
      'constructionType': new FormControl(personal.constructionType, Validators.required),
      'yrsInPremises': new FormControl(personal.yrsInPremises, Validators.required),
      'businessConstitution': new FormControl(personal.businessConstitution, Validators.required),
      'proofOfIdentity': new FormControl(personal.proofOfIdentity, Validators.required),
      'number': new FormControl(personal.number, Validators.required),
      'expiry': new FormControl(personal.expiry, Validators.required),
    };

    form = new FormGroup(group, { updateOn: 'blur' });
    return form;
  }

  buildForm2ReferenceForm(form: FormGroup, reference: Form2Reference) {

    let group = {
      'nameOfNominee': new FormControl(reference.nameOfNominee,
        [
          Validators.required,
          Validators.maxLength(30),
          Validators.minLength(1),
          Validators.pattern(new RegExp(this.stringRegex))
        ]),
      'dateOfBirth': new FormControl(reference.dateOfBirth,
        Validators.required),
      'relationship': new FormControl(reference.relationship,
        Validators.required),
      'spouseName': new FormControl(reference.spouseName,
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.minLength(1),
          Validators.pattern(new RegExp(this.stringRegex))
        ]),
      'motherName': new FormControl(reference.motherName,
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.minLength(1),
          Validators.pattern(new RegExp(this.stringRegex))
        ]),
      'referenceName1': new FormControl(reference.referenceName1,
        [
          Validators.required,
          Validators.maxLength(30),
          Validators.minLength(1),
          Validators.pattern(new RegExp(this.stringRegex))
        ]),
      'mobilePhone1': new FormControl(reference.mobilePhone1,
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.minLength(10),
        ]),
      'referenceName2': new FormControl(reference.referenceName2,
        [
          Validators.required,
          Validators.maxLength(30),
          Validators.minLength(1),
          Validators.pattern(new RegExp(this.stringRegex))
        ]),
      'mobilePhone2': new FormControl(reference.mobilePhone2,
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.minLength(10),
        ]),
      'modeOfCommunication': new FormControl(reference.modeOfCommunication, Validators.required),
      'usage': new FormControl(reference.usage, Validators.required)
    };

    form = new FormGroup(group, { updateOn: 'blur' });
    return form;
  }

  buildForm2BankDetailsForm(form: FormGroup, bank: Form2BankDetails) {

    let group = {
      'nameOfAccount': new FormControl(bank.nameOfAccount,
        [
          Validators.required,
          Validators.maxLength(200),
          Validators.minLength(1),
          Validators.pattern(new RegExp(this.stringRegex))
        ]),
      'ifsc': new FormControl(bank.ifsc,
        [
          Validators.required,
          Validators.maxLength(30),
          Validators.minLength(1),
          Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'bankName': new FormControl(bank.bankName,
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.minLength(1),
          Validators.pattern(new RegExp(this.stringRegex))
        ]),
      'branchName': new FormControl(bank.branchName,
        [
          Validators.required,
          Validators.maxLength(20),
          Validators.minLength(1),
          Validators.pattern(new RegExp(this.stringRegex))
        ]),
      'accountType': new FormControl(bank.accountType,
        [
          Validators.required
        ]),
      'accountNumber': new FormControl(bank.accountNumber,
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.minLength(1),
          Validators.pattern(new RegExp(this.alphaNumericRegex))
        ]),
      'accountSince': new FormControl(bank.accountSince,
        [
          Validators.required,
        ]),
      'repaymentFlag': new FormControl(bank.repaymentFlag,
        [
          Validators.required,
        ]),
    };

    form = new FormGroup(group, { updateOn: 'blur' });
    return form;
  }

  buildTrackQuoteForm(form: FormGroup, track: SearchQuote) {
    let group = {
      'applicationNo': new FormControl(track.applicationNo),
      'applicantName': new FormControl(track.applicantName,
        [
          Validators.maxLength(30),
          Validators.pattern(new RegExp(this.stringRegex))
        ]),
      'panNumber': new FormControl(track.panNumber,
        [
          Validators.pattern(new RegExp(this.panRegex))
        ]),
    };
    form = new FormGroup(group, { updateOn: 'blur' });
    return form;
  }

  // buildPreApprovalStatusForm(form: FormGroup, status: StatusForm) {
  //   let group = {
  //     'timeFrame': new FormControl(status.timeFrame),
  //     'period': new FormControl(status.period),
  //   };
  //   form = new FormGroup(group, { updateOn: 'blur' });
  //   return form;
  // }

  buildPreApprovalStatusForm2(form: FormGroup, status: approvalDate) {
    let group = {
      'fromDate': new FormControl(status.fromDate, Validators.required),
      'toDate': new FormControl(status.toDate),
    };
    form = new FormGroup(group, { updateOn: 'blur' });
    if (form) {
      let validator: any = {
        required: true,
        dateValidation: true,
      }
      this.addDynamicValidators(form.controls['toDate'] as FormControl, validator, form, 0, 0);

      // validator = {
      //   required: true,
      //   toDateValidation: true,
      // }
      // this.addDynamicValidators(form.controls['fromDate'] as FormControl, validator, form);
    }
    return form;
  }

  buildUserWorkloadForm(form: FormGroup, user: Workload) {
    let group = {
      'users': new FormControl(user.users, Validators.required),
      'task': new FormControl(user.task),
      'taskStatus': new FormControl(user.taskStatus),
      'period': new FormControl(user.period),
    };
    form = new FormGroup(group, { updateOn: 'blur' });
    return form;
  }


  addDynamicValidators(formControl: FormControl, validator: any, form: FormGroup, downPayemntMaxAmount, downPayemntMinAmount) {
    let args: any[] = [];
    if (validator.required) {
      args.push(Validators.required);
    }
    if (validator.email) {
      args.push(Validators.email);
    }
    if (validator.maxValue) {
      args.push(Validators.max(validator.maxValue));
    }
    if (validator.minValue) {
      args.push(Validators.min(validator.minValue));
    }
    if (validator.maxLength) {
      args.push(Validators.maxLength(validator.maxLength));
    }
    if (validator.minLength) {
      args.push(Validators.minLength(validator.minLength));
    }
    if (validator.netSalaryValidator) {
      args.push(netSalaryValidator(form));
    }
    if (validator.tinNumberValidator) {
      args.push(tinNumberValidator(form));
    }
    if (validator.confirmTinValidation) {
      args.push(confirmTinValidation(form));
    }
    if (validator.panNumberValidator) {
      args.push(panNumberValidator(form));
    }
    if (validator.confirmPanValidation) {
      args.push(confirmPanValidation(form));
    }
    if (validator.pincodeValidator) {
      args.push(pincodeValidator(form));
    }
    if (validator.confirmEmailValidation) {
      args.push(confirmEmailValidation(form));
    }
    if (validator.confirmMobileValidation) {
      args.push(confirmMobileValidation(form));
    }
    if (validator.pattern) {
      args.push(Validators.pattern(new RegExp(validator.pattern)));
    }
    if (validator.nameValidation) {
      args.push(nameValidation(form));
    }
    if (validator.midNameValidation) {
      args.push(midNameValidation(form));
    }
    if (validator.dateValidation) {
      args.push(dateValidator(form));
    }
    if (validator.toDateValidation) {
      args.push(toDateValidator(form));
    }
    // if (validator.aadharValidation) {
    //   args.push(aadharValidation(form));
    // }
    if (validator.itrIncomeValidation) {
      args.push(itrIncomeValidation(form));
    }
    if (validator.downpaymentMaxValidation) {
      args.push(downpaymentMaxValidator(form, downPayemntMaxAmount));
    }
    if (validator.downpaymentMinValidation) {
      args.push(downpaymentMinValidator(form, downPayemntMinAmount));
    }
    //IN CASE ANY MORE VALIDATOR ARE REQUIRED ADD  IF CONDITION HERE.
    formControl.setValidators(args);
    formControl.updateValueAndValidity({ emitEvent: false });
  }
}